const ADMIN = "Admin";
const USER = "User";
const BLOCKED = "Blocked";

export {ADMIN, USER, BLOCKED};